<template>
  <!--质量经理打回-重新上传-->
  <!-- 自检报告查看 -->
  <h-form-page-new :title="h_i18n('c26fb6e1d10127af8a396d1ea36326b2')" @inspection-update="inspectionUpdate" style="background: #F2F4F7;padding:16px;">
    <div class="page">
      <div class="table-top">
        <div class="title-table">
          <!-- 基本信息 -->
          <div class="left" style="color: #1D2129;font-weight: bold;font-size: 14px;">{{ h_i18n('9e5ffa068ed435ced73dc9bf5dd8e09c') }}</div>
          <!-- 样检单号： -->
          <div class="right h-global-font--blue" style="font-size: 14px" @click="lookPlan">{{ h_i18n('0dfedd58f37571cc86caec5f09366bdb') }}{{ tableData.patternPlanId }}</div>
        </div>
        <div class="detail-content" style="margin-top: 6px;">
          <div class="detail-item">
            <!-- 模块商编码： -->
            <div class="item-label">{{ h_i18n('7f8d2de5a7210365dbc66eabdbfc0315') }}</div>
            <div class="item-content">{{ tableData.supplyCode }}</div>
          </div>
          <div class="detail-item">
            <!-- 模块商名称： -->
            <div class="item-label">{{ h_i18n('7d652e44d79974973925e54ae93c8393') }}</div>
            <div class="item-content">{{ tableData.supplyName}}</div>
          </div>
          <div class="detail-item">
            <!-- 专用号： -->
            <div class="item-label">{{ h_i18n('7c7fefb36371a5a9ab5338c98790c67c') }}</div>
            <div class="item-content">{{tableData.mtlNo }}</div>
          </div>
          <div class="detail-item">
            <!-- 物料名称： -->
            <div class="item-label">{{ h_i18n('7a0ae7305076f170b4a920ef5f3f04f9') }}</div>
            <div class="item-content">{{ tableData.mtlName }}</div>
          </div>
        </div>
        <div class="detail-content" style="margin-top: 12px;">
          <div class="detail-item">
            <!-- 自检类别： -->
            <div class="item-label">{{ h_i18n('e9578dda62b775c828a9cc05e05bbf61') }}</div>
            <div class="item-content">{{ tableData.materialLevel }}</div>
          </div>
          <div class="detail-item">
            <!-- 产业线： -->
            <div class="item-label">{{ h_i18n('cfff4b0c9ca7597fcf9d6e88d6aaece1') }}</div>
            <div class="item-content">{{ tableData.plName }}</div>
          </div>
          <div class="detail-item">
            <!-- 工厂小微： -->
            <div class="item-label">{{ h_i18n('2153e04c74140dd4926dd724aad0d2a7') }}</div>
            <div class="item-content">{{ tableData.sybName }}</div>
          </div>
          <div class="detail-item">
            <!-- 检验方式： -->
            <div class="item-label">{{ h_i18n('62d773f2fea6b5cc3313bfa1d0af5df4') }}</div>
            <div class="item-content">
              <!-- 标准检 -->
              <span v-if="tableData.checkTypeId == 1104" class="warningColor">{{ h_i18n('dc6f3f35fdea3ae845d417b4c4127e20') }}</span>
              <!-- 免检 -->
              <span v-else-if="tableData.checkTypeId == 1105" class="successColor">{{ h_i18n('ca3179550e48755ebbf44397f7af708b') }}</span>
              <!-- 加速检 -->
              <span v-else-if="tableData.checkTypeId == 1106" class="blueColor">{{ h_i18n('0ab16539ed7be5709b361d350956ab43') }}</span>
              <!-- 停检 -->
              <span v-else-if="tableData.checkTypeId == 1141" class="dangerColor">{{ h_i18n('8177e5fe9e704bb4da0da6afe0da0da9') }}</span>
            </div>
          </div>
        </div>
        <div class="detail-content" style="margin-top: 12px;">
          <div class="detail-item">
            <!-- 自检应完成时间： -->
            <div class="item-label">{{ h_i18n('acea584c9d462f33c473cd327b1fafdd') }}</div>
            <div class="item-content"><span>{{ time(tableData.supplierSelfCheckPlanDate, 3) }}</span></div>
          </div>
          <div class="detail-item">
            <!-- 文件状态： -->
            <div class="item-label">{{ h_i18n('1be8b03ef2808b91ee3198b2fd219167') }}</div>
            <div class="item-content">
              <!-- 自检待上传 -->
              <div v-if="tableData.selfCheckState===2226">{{ h_i18n('362b0ac9a97560271534c66a3abd336b') }}</div>
              <!-- 自检待审核 -->
              <div class="warningColor" v-if="tableData.selfCheckState===2227">{{ h_i18n('31f3cda12f66898443a5cbae5a59a54f') }}</div>
              <!-- 自检待校核 -->
              <div class="warningColor" v-if="tableData.selfCheckState===2229">{{ h_i18n('ad99be837949c976c9442b08d5fe0983') }}</div>
              <!-- 自检审核驳回 -->
              <div class="dangerColor" v-if="tableData.selfCheckState===2228">{{ h_i18n('b1d80f4be451870aad10bd88b42f4c27') }}</div>
              <!-- 自检不合格 -->
              <div class="dangerColor" v-if="tableData.selfCheckState===2236">{{ h_i18n('fe9cbe5433b77ade8db68484af57bdeb') }}</div>
              <!-- 自检合格 -->
              <div class="successColor" v-if="tableData.selfCheckState===2230">{{ h_i18n('3aa9d9ef4b6973e14519ec1a37189e27') }}</div>
              <!-- 自检待批准 -->
              <div class="successColor" v-if="tableData.selfCheckState===2248">{{ h_i18n('b1b793381d349ecd6b67cfacc2b0ab40') }}</div>
              <!-- 自检批准驳回 -->
              <div class="successColor" v-if="tableData.selfCheckState===2249">{{ h_i18n('2cf37ff600fbfd0f0728b6202b1f328c') }}</div>
              <!-- 自检校核驳回 -->
              <div class="successColor" v-if="tableData.selfCheckState===2501">{{ h_i18n('adfeeda281aa7bc55d1e0da277c87538') }}</div>
              <div v-else></div>
            </div>
          </div>
          <div class="detail-item">
            <!-- 产地： -->
            <div class="item-label">{{ h_i18n('0985401cbacaabafcfe3365628af9393') }}</div>
            <div class="item-content">{{ mainData.factoryAddress }}</div>
          </div>
        </div>
        <div class="detail-content" style="margin-top: 12px;"  v-if="selfDelayReasonShow">
          <div class="detail-item">
            <!-- 自检拖期原因 -->
            <div class="item-label">{{ h_i18n('001768F5D0D251C2E86828DBCE241DA7') }}：</div>
            <div class="item-content" style="transform: translate(5px, -5px);">
              <el-select v-model="selfDelayReason" placeholder="请选择" style="width: 100%;"
                @change="selfDelayReasonChoose()" filterable disabled>
                <el-option v-for="item in selfDelayReasonData" :value="item.value" :key="item.value" :label="item.label"></el-option>
              </el-select>
            </div>
          </div>
          <div class="detail-item" style="width:75%;" v-if="selfDelayReasonRemarkShow">
            <!-- 自检拖期其它原因说明 -->
            <div class="item-label">{{ h_i18n('D4FF3F11C2E31A4448B6D158CDEB3690') }}：</div>
            <div class="item-content" style="transform: translateY(5px, -5px);width: 90%;">
              <el-input class="default_input_style" v-model="selfDelayReasonRemark" show-word-limit maxlength="200" disabled :rows="3" type="textarea" placeholder="请输入"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="table-tab">
        <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
          <!-- 二三级物料 -->
          <el-tab-pane :label="h_i18n('749ad86b2e655706785f3e38b9e7031c')" name="1">
            <div class="tab-item">
              <div class="table-item-list">
                <!-- 二三级物料结论 -->
                <div class="item-one item-bg">{{ h_i18n('72f21ebb9b237f248844dde337548450') }}</div>
                <!-- 不合格；合格 -->
                <div class="item-one" style="color: #F53F3F;">{{ mainData.materialResult === "F" ? h_i18n('6e5a122013138ad189517d5d0a1c0891') : mainData.materialResult === "P" ? h_i18n('86f720320b77bb62311f0a4811db04fe') : "" }}</div>
                <!-- 不合格原因 -->
                <div class="item-one item-bg" style="margin-left: 80px;">{{ h_i18n('61a26fd20db8541f06a7ff277b5d75f7') }}</div>
                <div class="item-two" style="color: #1D2129;">{{ mainData.materialRemark }}</div>
              </div>
              <div class="table-item-table">
                <!-- 新品检验计划 -->
                <h-table-card :title="h_i18n('19fde6e4eac33cf5a9befed79c2309c8')" :is-left="mainData.submitStatus!=='Y'?2:1" :h-data="tableList.sTMaterialsList" :is-right="mainData.submitStatus!=='Y'?1:0">
                  <!-- 请点击“查询”数据 -->
                  <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" border :data="tableList.sTMaterialsList" size="small"
                            @row-click.self="rowClick" :highlight-current-row="true" v-loading="tableListLoading"
                            @selection-change="listCheckBoxChange" ref="sTMaterialsList">
                    <!-- 序号 -->
                    <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')"></el-table-column>
                    <!-- 物料等级 -->
                    <el-table-column :label="h_i18n('d95cf47ff6633b3bea0c6b2c82f50107')" width="200">
                      <template #default="{row}">
                        <!-- I级；II级；III级 -->
                        <div class="text_item">{{ row.series === "1" ? h_i18n('a86b76d1ac7e23fbe6811914dddedd66') : row.series === "2" ? h_i18n('50657dd5fba0f4c56301994b9435ed73') : row.series === "3" ? h_i18n('6d29d5c1c563430c254a0571e5498a5f') : "" }}</div>
                      </template>
                    </el-table-column>
                    <!-- 零件号码 -->
                    <el-table-column :label="h_i18n('82428b489879f605914215b9876caa40')" min-width="200">
                      <template #default="{row}">
                        <div class="text_item">{{ row.partNumber }}</div>
                      </template>
                    </el-table-column>
                    <!-- 零件名称 -->
                    <el-table-column :label="h_i18n('2bb79b0b11fb5f902349598676e2060e')" min-width="200">
                      <template #default="{row}">
                        <div class="text_item">{{ row.partName }}</div>
                      </template>
                    </el-table-column>
                    <!-- 材料名称 -->
                    <el-table-column :label="h_i18n('9ee1d06b4fb650c3e5fcc49929675caf')" min-width="200">
                      <template #default="{row}">
                        <div class="text_item">{{ row.materialName }}</div>
                      </template>
                    </el-table-column>
                    <!-- 规格参数 -->
                    <el-table-column :label="h_i18n('40c9875bd7978fac4de81ef58a454d28')" min-width="200">
                      <template #default="{row}">
                        <div class="text_item">{{ row.specification }}</div>
                      </template>
                    </el-table-column>
                    <!-- 自制/外协零件 -->
                    <el-table-column :label="h_i18n('ed765ced3449b75aa70a4f5c10ad1334')" prop="Zip" width="230">
                      <template #default="{row}">
                        <div class="text_item">{{ row.partStatusList.join(",") }}</div>
                      </template>
                    </el-table-column>
                    <!-- 产品/材料供应商 -->
                    <el-table-column :label="h_i18n('4dfbb9aa4ac63454b70dfd8bbe09def7')" prop="Zip" width="160">
                      <template #default="{row}">
                        <div class="text_item">{{ row.productSupplier }}</div>
                      </template>
                    </el-table-column>
                  </el-table>
                </h-table-card>
              </div>
            </div>
          </el-tab-pane>
          <!-- 检验测试 -->
          <el-tab-pane :label="h_i18n('23e0cee4c780d1d70657b0b32005fed2')" name="2">
            <div class="tab-item">
              <div class="table-item-list">
                <!-- 检验测试结论 -->
                <div class="item-one item-bg">{{ h_i18n('2c2aa6cab81f0b72ba963b4c8cc04329') }}</div>
                <!-- 不合格；合格 -->
                <div class="item-one" style="color: #F53F3F;">{{ mainData.inspectionResult === "F" ? h_i18n('6e5a122013138ad189517d5d0a1c0891') : mainData.inspectionResult === "P" ? h_i18n('86f720320b77bb62311f0a4811db04fe') : "" }}</div>
                <!-- 不合格原因 -->
                <div class="item-one item-bg" style="margin-left: 80px;">{{ h_i18n('61a26fd20db8541f06a7ff277b5d75f7') }}</div>
                <div class="item-two" style="color: #1D2129;">{{ mainData.instestRemark }}</div>
              </div>
              <div class="table-item-table">
                <!-- 新品检验计划 -->
                <h-table-card :title="h_i18n('19fde6e4eac33cf5a9befed79c2309c8')">
                  <!-- 请点击“查询”数据 -->
                  <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" border :data="tableList.inspectionTesting" size="small"
                            @row-click="rowClick" :highlight-current-row="true" v-loading="tableListLoading"
                            ref="inspectionTesting">
                    <!-- 序号 -->
                    <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')"></el-table-column>
                    <el-table-column label="*" width="60">
                      <template #header>
                        <div class="dangerColor center">*</div>
                      </template>
                      <template #default="{row}">
                        <div class="dangerColor center" v-if="row.isMust==='Y'">*</div>
                      </template>
                    </el-table-column>
                    <!-- 项目 -->
                    <el-table-column :label="h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')" prop="project" min-width="230">
                      <template #default="{row}">
                        <div class="text_item">{{ row.project }}</div>
                      </template>
                    </el-table-column>
                    <!-- 是否合格 -->
                    <el-table-column :label="h_i18n('3ba97bd751e79dff382d6ca65e4e3553')" prop="State" width="100">
                      <template #default="{row}">
                        <!-- 是；否 -->
                        <div class="text_item">{{ row.qualifiedStatus === "Y" ? h_i18n('0a60ac8f02ccd2cf723f927284877851') : row.qualifiedStatus === "N" ? h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') : "/" }}</div>
                      </template>
                    </el-table-column>
                    <!-- 检测时间 -->
                    <el-table-column :label="h_i18n('44c4227175922c94497714edab9db531')" prop="City" width="230">
                      <template #default="{row}">
                        <div class="text_item">{{ time(row.testTime) }}</div>
                      </template>
                    </el-table-column>
                    <!-- 附件 -->
                    <el-table-column :label="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')" prop="Address" width="200">

                      <template #default="{row}">
                        <template v-if="row.project==='出厂检验报告模板'">
                          <!-- 查看 -->
                          <div class="h-global-font--blue text_item_delete" @click="redact(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</div>
                        </template>
                        <template v-else>
                          <a @click="lookPicture(row.fileUuid)" style="color:#165dff;display:block;text-overflow: ellipsis;overflow: hidden;cursor:pointer;">{{ row.fileName }}</a>
                        </template>
                      </template>

                    </el-table-column>
                    <!-- 报告出具人 -->
                    <el-table-column :label="h_i18n('1470d600e4e06f5ea0100fc0bd2a363c')" prop="Zip" width="200">
                      <template #default="{row}">
                        <div class="text_item">{{ row.submitMan }}</div>
                      </template>
                    </el-table-column>
                    <!-- 外检判定 -->
                    <el-table-column :label="h_i18n('6c3d4f5a0a2b4d7de6ed3deaa5841213')" width="100">
                      <template #default="{row}">
                        <div class="text_item">
                          <!-- 合格 -->
                          <span v-if="row.result === 'P'">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
                          <!-- 不合格 -->
                          <span v-else-if="row.result === 'F'">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
                          <span v-else-if="row.result === 'N/A'">N/A</span>
                          <span v-else></span>
                        </div>
                        <!-- <div class="text_item">{{ row.result === "F" ? "不合格" : row.result === "P" ? "合格" : "" }}</div> -->
                      </template>
                    </el-table-column>
                  </el-table>
                </h-table-card>
              </div>
            </div>
          </el-tab-pane>
          <!-- 技术标准 -->
          <el-tab-pane :label="h_i18n('542c3a3ec2d96f011386760d7382940f')" name="3">
            <div class="tab-item">
              <div class="table-item-list">
                <!-- 技术标准结论 -->
                <div class="item-one item-bg">{{ h_i18n('4a95f1dad44389dd923b677b7b00317e') }}</div>
                <!-- 不合格；合格 -->
                <div class="item-one" style="color: #F53F3F;">{{ mainData.technicalResult === "F" ? h_i18n('6e5a122013138ad189517d5d0a1c0891') : mainData.technicalResult === "P" ? h_i18n('86f720320b77bb62311f0a4811db04fe') : "" }}</div>
                <!-- 不合格原因 -->
                <div class="item-one item-bg" style="margin-left: 80px;">{{ h_i18n('61a26fd20db8541f06a7ff277b5d75f7') }}</div>
                <div class="item-two" style="color: #1D2129;">{{ mainData.techstandardRemark }}</div>
              </div>
              <div class="table-item-table">
                <!-- 新品检验计划 -->
                <h-table-card :title="h_i18n('19fde6e4eac33cf5a9befed79c2309c8')">
                  <!-- 请点击“查询”数据 -->
                  <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" border :data="tableList.technicalStandard" size="small"
                            @row-click="rowClick" :highlight-current-row="true" v-loading="tableListLoading"
                            ref="technicalStandard">
                    <!-- 序号 -->
                    <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')"></el-table-column>
                    <el-table-column label="*" width="60">
                      <template #header>
                        <div class="dangerColor center">*</div>
                      </template>
                      <template #default="{row}">
                        <div class="dangerColor center" v-if="row.isMust==='Y'">*</div>
                      </template>
                    </el-table-column>
                    <!-- 项目 -->
                    <el-table-column :label="h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')" min-width="230">
                      <template #default="{row}">
                        <div class="text_item">{{ row.project }}</div>
                      </template>
                    </el-table-column>
                    <!-- 是否合格 -->
                    <el-table-column :label="h_i18n('3ba97bd751e79dff382d6ca65e4e3553')" width="100">
                      <template #default="{row}">
                        <!-- 是；否 -->
                        <div class="text_item">{{ row.qualifiedStatus === "Y" ? h_i18n('0a60ac8f02ccd2cf723f927284877851') : row.qualifiedStatus === "N" ? h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') : "/" }}</div>
                      </template>
                    </el-table-column>
                    <!-- 附件 -->
                    <el-table-column :label="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')" width="200">
                      <template #default="{row}">
                        <a @click="lookPicture(row.fileUuid)" style="color:#165dff;display:block;text-overflow: ellipsis;overflow: hidden;cursor:pointer;">{{ row.fileName }}</a>
                      </template>
                    </el-table-column>
                    <!-- 报告出具人 -->
                    <el-table-column :label="h_i18n('1470d600e4e06f5ea0100fc0bd2a363c')" width="200">
                      <template #default="{row}">
                        <div class="text_item">{{ row.submitMan }}</div>
                      </template>
                    </el-table-column>
                    <!-- 外检判定 -->
                    <el-table-column :label="h_i18n('6c3d4f5a0a2b4d7de6ed3deaa5841213')" width="100">
                      <template #default="{row}">
                        <!-- 不合格；合格 -->
                        <div class="text_item">{{ row.result === "F" ? h_i18n('6e5a122013138ad189517d5d0a1c0891') : row.result === "P" ? h_i18n('86f720320b77bb62311f0a4811db04fe') : "" }}</div>
                      </template>
                    </el-table-column>
                  </el-table>
                </h-table-card>
              </div>
            </div>
          </el-tab-pane>
          <!-- 有害物质 -->
          <el-tab-pane :label="h_i18n('f7ef9633c64559e80c654567ca5ddd96')" name="4">
            <div class="tab-item">
              <div class="table-item-list">
                <!-- 有害物质结论 -->
                <div class="item-one item-bg">{{ h_i18n('ca8668db1e1461091b88cd30fd945a0e') }}</div>
                <!-- 不合格；合格 -->
                <div class="item-one" style="color: #F53F3F;">{{ mainData.rohsResult === "F" ? h_i18n('6e5a122013138ad189517d5d0a1c0891') : mainData.rohsResult === "P" ? h_i18n('86f720320b77bb62311f0a4811db04fe') : "" }}</div>
                <!-- 不合格原因 -->
                <div class="item-one item-bg" style="margin-left: 80px;">{{ h_i18n('61a26fd20db8541f06a7ff277b5d75f7') }}</div>
                <div class="item-two" style="color: #1D2129;">{{ mainData.rohsRemark }}</div>
              </div>
              <div class="table-item-table">
                <!-- 新品检验计划 -->
                <h-table-card :title="h_i18n('19fde6e4eac33cf5a9befed79c2309c8')">
                  <!-- 请点击“查询”数据 -->
                  <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" border :data="tableList.hazardousSubstances" size="small"
                            @row-click="rowClick" :highlight-current-row="true" v-loading="tableListLoading"
                            ref="hazardousSubstances">
                    <!-- 序号 -->
                    <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')"></el-table-column>
                    <el-table-column label="*" width="60">
                      <template #header>
                        <div class="dangerColor center">*</div>
                      </template>
                      <template #default="{row}">
                        <div class="dangerColor center" v-if="row.isMust==='Y'">*</div>
                      </template>
                    </el-table-column>
                    <!-- 项目 -->
                    <el-table-column :label="h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')" min-width="230">
                      <template #default="{row}">
                        <div class="text_item">{{ row.project }}</div>
                      </template>
                    </el-table-column>
                    <!-- 宣告表编号 -->
                    <el-table-column :label="h_i18n('c2cf8689fd0e8203797dbbd7f8475ff0')" width="270">
                      <template #default="{row}">
                        <div class="text_item">{{ row.rohsNo }}</div>
                      </template>
                    </el-table-column>
                    <!-- 宣告表详情 -->
                    <el-table-column :label="h_i18n('97e203313843643e68a5225ae227359e')" width="220">
                      <template #default="{row}">
                        <!-- 查看 -->
                        <div class="h-global-font--blue text_item_delete" @click="goDetail(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</div>
                      </template>
                    </el-table-column>
                    <!-- 附件 -->
                    <el-table-column :label="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')" width="200">
                      <template #default="{row}">
                        <a @click="lookPicture(row.fileUuid)" style="color:#165dff;display:block;text-overflow: ellipsis;overflow: hidden;cursor:pointer;">{{ row.fileName }}</a>
                      </template>
                    </el-table-column>
                    <!-- 是否合格 -->
                    <el-table-column :label="h_i18n('3ba97bd751e79dff382d6ca65e4e3553')" width="100">
                      <template #default="{row}">
                        <!-- 是；否 -->
                        <div class="text_item">{{ row.judge === "Y" ? h_i18n('0a60ac8f02ccd2cf723f927284877851') : row.judge === "N" ? h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') : "/" }}</div>
                      </template>
                    </el-table-column>
                    <!-- 报告出具人 -->
                    <el-table-column :label="h_i18n('1470d600e4e06f5ea0100fc0bd2a363c')" width="200">
                      <template #default="{row}">
                        <div class="text_item">{{ row.submitMan }}</div>
                      </template>
                    </el-table-column>
                  </el-table>
                </h-table-card>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="table-footer">
        <form-body-new>
          <tr class="myTr">
            <!-- 自检报告提交人 -->
            <report-td-new :title="h_i18n('0f9e7f25f268037327547e57aeae6d4a')" bg-color="#F1F2F8" colspan="3:5">{{ mainData.submitMan }}</report-td-new>
            <!-- 自检应完成时间 -->
            <report-td-new :title="h_i18n('1ca7175c20c07333353d66197609f2ce')" bg-color="#F1F2F8" colspan="3:5">{{ time(tableData.supplierSelfCheckPlanDate) }}</report-td-new>
            <!-- 自检报告提交时间 -->
            <report-td-new :title="h_i18n('809d202445fc06a46b04ac9e030cce30')" bg-color="#F1F2F8" colspan="3:5">{{ time(mainData.submitDate, 6) }}</report-td-new>
          </tr>
          <tr>
            <!-- 质量部长批准结论 -->
            <report-td-new :title="h_i18n('906ec6118874910a54fe78a78ad83b7e')" bg-color="#F1F2F8" colspan="3:5">
              <!-- 驳回 -->
              <div v-if="mainData.supplyAuditStatus === 'R'" class="dangerColor pointer" @click="lookDrawer">{{ h_i18n('32525478cd5c1c93de9c71246021b595') }}</div>
              <!-- 通过 -->
              <div v-else-if="mainData.supplyAuditStatus === 'Y'" class="h-global-font--blue" @click="lookDrawer">{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</div>
              <div v-else></div>
            </report-td-new>
            <!-- 质量部长 -->
            <report-td-new :title="h_i18n('4ed5b49161457958596caef59bfc60b0')" bg-color="#F1F2F8" colspan="3:5">{{ mainData.supplyAuditMan }}</report-td-new>
            <!-- 质量部长批准时间 -->
            <report-td-new :title="h_i18n('4c07c7c2e7d50070e864c66bd9b9e21c')" bg-color="#F1F2F8" colspan="3:5">{{ time(mainData.supplyAuditDate, 6) }}</report-td-new>
          </tr>
          <tr>
            <!-- 外检审核结论 -->
            <report-td-new :title="h_i18n('7f0a75e23d640925d89a7151c9de060e')" bg-color="#F1F2F8" colspan="3:5">
              <!-- 不合格 -->
              <div class="dangerColor" v-if="mainData.checkStatus==='F'">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</div>
              <!-- 合格 -->
              <div v-else-if="mainData.checkStatus==='P'">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</div>
              <!-- 打回 -->
              <div v-else-if="mainData.checkStatus==='R'">{{ h_i18n('9a7b15dccc5cda2e3db1110678576104') }}</div>
              <div v-else></div>
            </report-td-new>
            <!-- 外检审核人 -->
            <report-td-new :title="h_i18n('77112d99f3debb6b40c6d7dc6f71c1eb')" bg-color="#F1F2F8" colspan="3:5">{{ $route.query.dataFrom == 'sqm' ? "-" : mainData.checkMan }}</report-td-new>
            <!-- 外检审核时间 -->
            <report-td-new :title="h_i18n('16eabef9d8dacf4bf38c671adf4ff374')" bg-color="#F1F2F8" colspan="3:5">{{ time(mainData.checkDate, 6) }}</report-td-new>
          </tr>
          <tr class="myTr1">
            <!-- 外检负责人校核结论 -->
            <report-td-new :title="h_i18n('50870b5c342d62e61dad40cafd007ace')" bg-color="#F1F2F8" colspan="3:5">
              <!-- 不合格 -->
              <div class="dangerColor" v-if="tableData.iqcLeaderConclusion==='F'">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</div>
              <!-- 合格 -->
              <div v-else-if="tableData.iqcLeaderConclusion==='P'">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</div>
              <!-- 打回 -->
              <div v-else-if="tableData.iqcLeaderConclusion==='R'">{{ h_i18n('9a7b15dccc5cda2e3db1110678576104') }}</div>
              <div v-else></div>
            </report-td-new>
            <!-- 外检负责人 -->
            <report-td-new :title="h_i18n('fc4ed0419f8799cba7678812a2e3eae1')" bg-color="#F1F2F8" colspan="3:5">{{ $route.query.dataFrom == 'sqm' ? "-" : tableData.iqcLeaderAuditApprovorName }}</report-td-new>
            <!-- 负责人校核时间 -->
            <report-td-new :title="h_i18n('67cff284a29663057baa6c1d3043ad53')" bg-color="#F1F2F8" colspan="3:5">{{ time(tableData.iqcLeaderAuditDate, 6) }}</report-td-new>
          </tr>
        </form-body-new>
        <h-button-group align="center" style="margin-top: 16px">
          <!-- 返回 -->
          <h-button type="primary" @click="goBack">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </div>
      <!--质量部长校核-->
      <el-drawer v-model="ratify" :show-close="false" size="560px">
        <template #title>
          <!-- 新品报验批准 -->
          <div class="titleDrawer">{{ h_i18n('3365f22fb92ca9e0c7acfe00767d0c23') }}</div>
          <h-button style="margin-left: 10px" type="warning" @click="ratify=false">
            <template #icon>
              <close theme="outline"/>
            <!-- 关闭 -->
            </template>{{ h_i18n('b15d91274e9fc68608c609999e0413fa') }}</h-button>
        </template>
        <template #default>
          <div>
            <!-- 请点击“查询”数据 -->
            <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="false" height="100%" border :data="tableList.approveList" size="small">
              <!-- 项目 -->
              <el-table-column prop="project" :label="h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')" width="120"></el-table-column>
              <!-- 批准结论 -->
              <el-table-column :label="h_i18n('c8fecf8b1438559e9914fbc473c15ae3')" width="100">
                <template #default="{row}">
                  <!-- 通过 -->
                  <div v-if="row.conclusion==='Y'">{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</div>
                  <!-- 不通过 -->
                  <div v-else-if="row.conclusion==='N'">{{ h_i18n('dec0624c91cfca219e1b41ce89c19780') }}</div>
                  <div v-else></div>
                </template>
              </el-table-column>
              <!-- 备注 -->
              <el-table-column prop="reason" :label="h_i18n('2432b57515b3627faddccb1dd1df206e')" min-width="260"></el-table-column>
            </el-table>
          </div>
        </template>
      </el-drawer>
    </div>
  </h-form-page-new>


</template>





<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import {Download, Http, Log, MultipleChoiceEnhancement} from "../Decorator";

export default {
  name: "RepulseSelfInspectionData",
  data() {
    return {
      activeName: "1",
      beforeData: {},
      tableData: {},
      mainData: {},
      tableList: {
        sTMaterialsList: [],
        inspectionTesting: [],
        technicalStandard: [],
        hazardousSubstances: [],
        approveList: []
      },
      tableListLoading: false,
      multipleSelection: [],
      fileUpload: false,
      nowItem: {},
      fileList: [],
      cataId: 1,
      loadingDown: false,
      upload: false,
      dataList: [],
      status: "",
      commitment: false,
      declarationFormList: [],
      name: "",

      ratify: false,
      approveList: [],
      commitmentRatify: false,
      formType: "",
      
      selfDelayReason:'',  // 自检拖期原因
      selfDelayReasonRemark:'', // 自检拖期自定义原因
      selfDelayReasonData:[],  // 自检拖期列表
      selfDelayReasonShow:false,// 自检拖期原因输入 是否显示
      selfDelayReasonRemarkShow:false,// 自检拖期自定义原因输入 是否显示
    }
  },
  mounted() {
    this.name = this.$route.query.name
    this.init()
  },
  methods: {
    h_i18n,
    // 查询状态表
    getBaseValues(){
      this.$http({
        method: "post",
        url: "/base/basicData/listBaseValuesByIds",
        data: [112],
      }).then((res) => {
        if (res.data.code === "200") {
          res.data.data.forEach(item=>{
            // 拖期原因走配置表
            if(item.valueTypeId === 112){
              this.selfDelayReasonData.push({value:item.valueId,label:item.valueName})
            }
          })
        } else {
        }
      }).catch((err) => {
      });
    },
    lookPicture (url) {
      window.open(url)
    },
    //看批准
    lookDrawer() {
      this.ratify = true
    },
    goDetail(row) {
      if (row.rohsNo && row.rohsNo != '无') {
        // let url = process.env.NODE_ENV === "production" ? "http://sqm.haier.net/" : "http://sqm-test.qd-huangdao-test.haier.net/"
        // console.log(url + "newproduct/rohs_detail_haier_index?id=" + row.rohsNo)
        
        let routeData = this.$router.resolve({
          name: "rohsDeclarationFormDetail",
          query: {
            dataFrom:'sqm',
            kindType:'sqmDetail',
            supplyCode:this.tableData.supplyCode,
            supplyName:this.tableData.supplyName,
            rohsNo:row.rohsNo,
            id: row.rohsId
          }
        })
        // 新窗口打开
         window.open(routeData.href, "_blank")

        // window.open(url + "newproduct/rohs_detail_haier_index?id=" + row.rohsNo, "_black");
      } else {
        // 不是有效的宣告表编号, 请输入外检审核通过的宣告表编号。
        this.info(h_i18n('7435bdcd1a5956a38b04f15fef15d086'));
      }
    },
    lookPlan() {
      this.$router.push('/SampleInspectionFormLook?patternPlanId=' + this.tableData.patternPlanId+'&dataFrom=sqm')
    },
    lookM(a, b) {
      this.$router.push({
        name: "EnterpriseStandardList",
        query: {
          mtlNo: a,
          supplyCode: b
        }
      })
    },
    //****************************************************自检上传****************************************************

    //检验测试-编辑this.tableData.supplyCode, "", this.tableData.mtlNo
    redact() {
      // this.startLoading(h_i18n('f2a88edc8adb598632ba1c6f89279b89'))
      // this.$http({
      //   method: "GET",
      //   url: "/base/patternPlan/getMklInfo?mtlNo=" + this.tableData.mtlNo + "&supplyCode=" + this.tableData.supplyCode,
      // }).then((res) => {
      //   this.closeLoading()
      //   if (res.data.code === "200") {
          // this.$router.push({
          //   name: "ReportTemplate",
          //   query: {
          //     mtlNo: this.tableData.mtlNo,
          //     supplyCode: this.tableData.supplyCode,
          //     name: this.name,
          //     nickName: this.$route.query.nickName,
          //     dataFrom: "sqm",
          //     flag: "check",
          //     changeStatus: "N",
          //     versionNo: "V1.0",
          //     shipmentId: res.data.shipmentId,
          //     dataFromFlag: "close",
          //     roleCode: this.$route.query.roleCode
          //   }
          // })
          // let list = res.data
          // list.versionNo = "V1.0"
          // list.supplyCode = this.tableData.supplyCode
          // list.mtlNo = this.tableData.mtlNo
          // list.mtlName =  this.tableData.mtlName
          let list = {
              mtlNo: this.tableData.mtlNo,
              mtlName: this.tableData.mtlName,
              supplyCode: this.tableData.supplyCode
            };
          // this.$store.commit('setList', res);
          this.$router.push({
            name: "FactoryTemplateSqmTemplateDetail",
            query: {
              supplyCode: this.tableData.supplyCode,
              name: this.name,
              nickName: this.$route.query.nickName,
              dataFrom: "sqm",
              type: 1, 
              data: JSON.stringify(list),
              mtlNo:this.tableData.mtlNo,
            },
          });

        // } else {
        //   this.closeLoading()
        //   this.error(h_i18n('57738c8a6a20c40f544b2f5c17447298'))
        // }
      // })
    },
    //进入查询
    async init() {
      this.formType = this.$route.query.formType
      this.beforeData = JSON.parse(this.$route.query.data)
      await this.searchTableList()
      await this.selectDeclarationForm(this.tableData.supplyCode, "", this.tableData.mtlNo)
      this.getBaseValues()
      setTimeout(() => {
        this.postThisPageHeightMore()
      }, 10);
    },
    rohNoM(row) {
      let l = this.declarationFormList.filter(v => v.rohsNo === row.rohsNo)
      row.judge = l[0]["effectStatus"]
    },
    //时间格式化
    timeFormatter(row, type) {
      row[type] = this.time(row[type], 3)
    },
    //二三级物料，下载模版
    // 二三级物料导入模版.xlsx
    @Download("/base/fileDownload/downloadFile?filePath=mkhl/bukl/202307/a2478c44d2f94263800b62791a526618.xlsx", "GET", h_i18n('abee8ba959290abc34b8cb12bd4f46d5'))
    download(callback) {
      callback().then(v => {
        this.info(v)
      }, v => {
        this.error(v)
      })
    },
    //关闭导入模版
    closeUpload() {
      this.upload = false
      this.dataList = []
      this.status = ""
    },
    //二三级物料，自制外协切换
    specificationChange(row) {
      // 自制；外协
      row.partStatus = row.partStatusList.join(",").replace(h_i18n('f5f45a306153e09e6b55aa8989e62e29'), "1").replace(h_i18n('762f7d6568ff7dcbccb00c818e08c451'), "2")
    },
    //删除上传后的文件
    deleteFile(row) {
      row.fileName = ""
      row.fileUuid = ""
    },
    //二三级物料，模版导入
    uploadTemplate(file) {
      const formData = new FormData()

      formData.append("myFile", file)
      this.dataList = []
      this.status = ""
      // 解析中...
      this.startLoading(h_i18n('0b7da7ede9fae2ca88bfc8c9baabdfd1'))
      this.$http({
        method: "post",
        url: "/base/specialMaterial/import?userId=" + this.$route.query.name + "&userName=" + this.$route.query.nickName,
        data: formData,
      }).then((res) => {
        if (res.data.code === "200") {
          this.status = "success"
          // 导入成功
          this.dataList = [h_i18n('b6d16a8173dd0d43f580bc6882dc5e9a')]
          this.closeLoading()
          this.paginationQuery(this.pageNation.pageIndex)
        } else {
          this.status = "error"
          this.dataList = res.data.data
          this.closeLoading()
        }
      })
    },
    //上传文件
    uploadFile() {
      let uploadList = this.fileList.filter(v => v.status !== "success")
      if (uploadList.length === 0) {
        // 没有可以上传的文件！
        this.warning(h_i18n('d7be58c93368dc1797cd10e4a845ce30'))
        return
      }
      let formData = new FormData()
      uploadList.map(v => {
        formData.append('files', v.file)
        v.progress = 50
      })
      return this.$http({
        method: 'post',
        url: '/base/fileUpload/uploadToOssSaveUrl',
        headers: {'Content-Type': 'multipart/form-data'},
        data: formData,
        cache: false,
        processData: false,
        contentType: false,
      }).then((res) => {
        if (res.data.code === "0") {
          this.nowItem.fileUuid = res.data.data
          this.nowItem.fileName = uploadList[0].name
          console.log(uploadList[0].name)
          uploadList.map(v => {
            v.progress = 100
            v.status = "success"
          })
          this.success({
            // 提示
            title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
            // 上传成功
            message: h_i18n('a7699ba73144aad544eb9ac49f82749d'),
            // 确定
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            callback: async action => {
              this.fileUpload = false
              this.fileList = []
            }
          })
        } else {
          return Promise.reject()
        }
      }).catch((err) => {
        uploadList.map(v => {
          v.progress = 100
          v.status = "fail"
        })
        // 上传失败
        this.error(h_i18n('54e5de428ca9d59119d4624706215a4d'))
      });
    },
    //选择文件
    chooseFile(fileList) {
      console.log(fileList)
      this.fileList = [fileList]
    },
    //文件上传，报错信息和提示
    uploadError(text) {
      this.warning(text)
    },
    //上传附件，并且保存当前行信息
    fileUploadToOSS(row) {
      this.nowItem = row
      this.fileUpload = true
    },
    //二三级物料，列表选中
    listCheckBoxChange(val) {
      this.multipleSelection = val.map(v => v.checkFrontId);
    },
    //二三级物料，添加行
    @MultipleChoiceEnhancement()
    addItem() {
      this.tableList.sTMaterialsList.push({
        cataId: this.cataId,
        series: "",
        partNumber: "",
        partName: "",
        materialName: "",
        specification: "",
        partStatusList: [],
        partStatus: "",
        checkFront: false,
        checkFrontId: this.md5(this.uuid2()),
        checkFrontType: "sTMaterialsList"
      })
      console.log("添加")
    },
    //二三级物料，删除选中行
    deleteItemAll() {
      this.tableList.sTMaterialsList = this.tableList.sTMaterialsList.filter(v => !this.multipleSelection.includes(v.checkFrontId))
    },
    //二三级物料，删除单行
    @MultipleChoiceEnhancement()
    deleteItem(id) {
      this.tableList.sTMaterialsList = this.tableList.sTMaterialsList.filter(v => v.checkFrontId !== id)
    },
    //更新页面高度
    inspectionUpdate(height) {
      this.postThisPageHeight()
    },
    //点击四个列表TAB页
    @Log()
    handleClick(a) {
      console.log(a)
    },
    //查询样检单，四个列表和详情
    searchTableList() {
      // 数据查询中，请等待...
      this.startLoading(h_i18n('a1fa355af4de9de33a401ebb044bffb3'))
      this.tableListLoading = true
      return this.$http({
        method: "get",
        url: "/base/patternPlan/searchAPQPInfo?patternPlanId=" + this.beforeData.patternPlanId,
      }).then(res => {
        if (res.data.code === "200") {
          // console.log(res)
          this.mainData = res.data.data.apqpMain
          this.tableData = res.data.data.patternPlan
          // 自检拖期的回显
          if(this.tableData.selfDelayReason){
            this.selfDelayReason = this.tableData.selfDelayReason
            this.selfDelayReasonShow = true
          }
          if(this.tableData.selfDelayReasonRemark){
            this.selfDelayReasonRemark = this.tableData.selfDelayReasonRemark
            this.selfDelayReasonRemarkShow = true
          }
          this.tableList.approveList = res.data.data.approveList
          this.tableList.sTMaterialsList = this.addCheckId(res.data.data["apqpMaterialList"], "sTMaterialsList").map(v => {
            return {
              ...v,
              // 自制；外协
              partStatusList: v.partStatus.replace("1", h_i18n('f5f45a306153e09e6b55aa8989e62e29')).replace("2", h_i18n('762f7d6568ff7dcbccb00c818e08c451')).split(",").filter(v => v)
            }
          })


          this.tableList.inspectionTesting = this.addCheckId(res.data.data["apqpInstestList"], "inspectionTesting")

          if (this.tableList.inspectionTesting.map(v => {
            if(v.isMust === 'S' && v.result === 'N/A'){
              return "P"
            }else return v.result
          }).every(v => v === "P")) {
            this.mainData.inspectionResult = "P"
          } else if (this.tableList.inspectionTesting.map(v => v.result).every(v => !v)) {
            this.mainData.inspectionResult = ""
          } else {
            this.mainData.inspectionResult = "F"
          }
          this.tableList.technicalStandard = this.addCheckId(res.data.data["apqpTechstandardList"], "technicalStandard")
          if (this.tableList.technicalStandard.map(v => v.result).every(v => v === "P")) {
            this.mainData.technicalResult = "P"
          } else if (this.tableList.technicalStandard.map(v => v.result).every(v => !v)) {
            this.mainData.technicalResult = ""
          } else {
            this.mainData.technicalResult = "F"
          }
          this.tableList.hazardousSubstances = this.addCheckId(res.data.data["apqpRohsList"], "hazardousSubstances")
          this.tableListLoading = false
        } else {
          this.tableListLoading = false
        }
        this.closeLoading()
      }).catch(e => {
        this.closeLoading()
        this.tableListLoading = false
      })
    },
    //四个列表，每一行点击成输入框
    rowClick(row) {
      if (this.mainData.submitStatus !== "Y") {
        this.tableList[row.checkFrontType].forEach(v => v.checkFront = false)
        row.checkFront = true
      }
    },
    //样检单列表每一行格式化，添加一个key
    addCheckId(list, type) {
      return list.map(v => {
        return {
          ...v,
          checkFrontId: this.md5(v.id + v.project),
          checkFront: false,
          checkFrontType: type
        }
      })
    },
    //四个保存，分别
    save(type) {
      switch (type) {
        case "sTMaterialsList":
          this.saveTS()
          break
        case "inspectionTesting":
          this.saveCT()
          break
        case "technicalStandard":
          this.saveIS()
          break
        case "hazardousSubstances":
          this.saveHS()
          break
      }
    },
    //二三级物料暂存
    saveTS(t = true) {
      return this.$http({
        method: "POST",
        url: "/base/patternPlan/saveApqpMaterial?cataId=" + this.cataId,
        data: this.tableList.sTMaterialsList
      }).then(res => {
        if (res.data.data === "200" || res.data === true) {
          if (t) {
            // 保存成功
            this.success(h_i18n('3b108349b93f7c8c4e2346f8d48c092a'))
            this.searchTableList()
          }
        } else {
          if (t) {
            this.error({
              // 保存失败
              title: h_i18n('6de920b4e4e08b261cda928d9beefab4'),
              message: res.data.msg,
              // 确定
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721')
            })
          }
        }
      })
    },
    //检验测试暂存
    saveCT(t = true) {
      return this.$http({
        method: "POST",
        url: "/base/patternPlan/saveApqpInstest?cataId=" + this.cataId,
        data: this.tableList.inspectionTesting
      }).then(res => {
        if (res.data.data === "200" || res.data === true) {
          if (t) {
            // 保存成功
            this.success(h_i18n('3b108349b93f7c8c4e2346f8d48c092a'))
            this.searchTableList()
          }
        } else {
          if (t) {
            this.error({
              // 保存失败
              title: h_i18n('6de920b4e4e08b261cda928d9beefab4'),
              message: res.data.msg,
              // 确定
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721')
            })
          }
        }
      })
    },
    //技术标准暂存
    saveIS(t = true) {
      return this.$http({
        method: "POST",
        url: "/base/patternPlan/saveApqpTechstandard?cataId=" + this.cataId,
        data: this.tableList.technicalStandard
      }).then(res => {
        if (res.data.data === "200" || res.data === true) {
          if (t) {
            // 保存成功
            this.success(h_i18n('3b108349b93f7c8c4e2346f8d48c092a'))
            this.searchTableList()
          }
        } else {
          if (t) {
            this.error({
              // 保存失败
              title: h_i18n('6de920b4e4e08b261cda928d9beefab4'),
              message: res.data.msg,
              // 确定
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721')
            })
          }
        }
      })
    },
    //有害物质暂存
    saveHS(t = true) {
      return this.$http({
        method: "POST",
        url: "/base/patternPlan/saveApqpRohs?cataId=" + this.cataId,
        data: this.tableList.hazardousSubstances
      }).then(res => {
        if (res.data.data === "200" || res.data === true) {
          if (t) {
            // 保存成功
            this.success(h_i18n('3b108349b93f7c8c4e2346f8d48c092a'))
            this.searchTableList()
          }
        } else {
          if (t) {
            this.error({
              // 保存失败
              title: h_i18n('6de920b4e4e08b261cda928d9beefab4'),
              message: res.data.msg,
              // 确定
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721')
            })
          }
        }
      })
    },
    //提交接口
    submit() {
      return this.$http({
        method: "POST",
        url: "/base/patternPlan/submitApqp",
        data: this.mainData
      }).then(res => {
        if (res.data.data === "200" || res.data === true) {
          this.success({
            // 成功
            title: h_i18n('330363dfc524cff2488f2ebde0500896'),
            // 提交成功，请联系质量部长批准！！
            message: h_i18n('e9666b0e4405da3fe0aa1c46b2c42700'),
            // 确定
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            callback: () => {
              this.$router.back()
            }
          })
        } else {
          if (t) {
            this.error({
              // 提交失败
              title: h_i18n('f5d008dea7d2e953195a5588dea3c8e4'),
              message: res.data.msg,
              // 确定
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721')
            })
          }
        }
      })
    },
    //保存这四个页签
    async saveAll() {
      // 暂存中...
      this.startLoading(h_i18n('79d5d7ae21d4e63b3358da84d522f9f5'))
      await this.saveTS(false)
      await this.saveCT(false)
      await this.saveIS(false)
      await this.saveHS(false)
      this.closeLoading()
    },
    //查询宣告表//patternPlan/searchRohsList
    selectDeclarationForm(supplyCode, rohsNo, mtlNo) {
      return this.$http({
        method: "get",
        url: "/base/patternPlan/searchRohsList",
        params: {
          supplyCode: supplyCode,
          rohsNo: rohsNo,
          mtlNo: mtlNo
        }
      }).then(res => {
        if (res.data.code === "200") {
          //effectStatus
          this.declarationFormList = res.data.data
          this.tableListLoading = false
        } else {
          this.tableListLoading = false
        }
      }).catch(e => {
        this.tableListLoading = false
      })
    },
    //提交所有信息
    async submitAll() {
      if (!this.commitment) {
        this.info({
          // 提示
          title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
          // 勾选我司承诺，并且提交
          message: h_i18n('04863f191ef8f2b2b6c60a787213a611'),
          // 确定
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          // 取消
          cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
          callback: async (action) => {
            if (action === "confirm") {
              this.commitment = true
              // 提交中...
              this.startLoading(h_i18n('abe2c5d2b9a91f822cb1c1ae6aefef08'))
              await this.beforeSubmit()
              await this.saveTS(false)
              await this.saveCT(false)
              await this.saveIS(false)
              await this.saveHS(false)
              await this.submit()
              this.closeLoading()
            }
          }

        })
      } else {
        this.info({
          // 提示
          title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
          // 确认提交吗？
          message: h_i18n('51cef0b50d5ef83883d4f2d37895cfff'),
          // 确定
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          // 取消
          cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
          callback: async (action) => {
            if (action === "confirm") {
              // 提交中...
              this.startLoading(h_i18n('abe2c5d2b9a91f822cb1c1ae6aefef08'))
              await this.beforeSubmit()
              await this.saveTS(false)
              await this.saveCT(false)
              await this.saveIS(false)
              await this.saveHS(false)
              await this.submit()
              this.closeLoading()
            }
          }
        })
      }


    },
    //返回上一个页面
    goBack() {
      this.$router.back()
    },
    //空校验
    checkEmpty(option, list, tab) {
      let a = option.map(v => v.name)
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < a.length; j++) {
          if (list[i][a[j]] === "") {
            // 在；，第；行中，'；'不允许为空！
            let str = `${h_i18n('241d47a3ee97f044c1f043b9ea81855b')}${tab}${h_i18n('bf8fa96b224c11bc9ec04def0304ca26')}${i + 1}${h_i18n('860622be568ef6ba9ce20b0da1baa698')}${option[j].text}${h_i18n('ee68958200b067557acc666757b4bcaa')}`
            this.warning(str)
            this.closeLoading()
            return false
          }
        }
      }
      return true
    },
    //提交前验证所有要填写的信息
    beforeSubmit() {
      //二三级物料
      let a = [
        // I/II/III级
        {name: "series", text: h_i18n('911b9a994284ec787f4f24d6f25f3fe2')},
        // 零件号码
        {name: "partNumber", text: h_i18n('82428b489879f605914215b9876caa40')},
        // 零件名称
        {name: "partName", text: h_i18n('2bb79b0b11fb5f902349598676e2060e')},
        // 材料名称
        {name: "materialName", text: h_i18n('9ee1d06b4fb650c3e5fcc49929675caf')},
        // 规格参数
        {name: "specification", text: h_i18n('40c9875bd7978fac4de81ef58a454d28')},
        // 自制/外协零件
        {name: "partStatusList", text: h_i18n('ed765ced3449b75aa70a4f5c10ad1334')}
      ]
      //检验测试
      let b = [
        // 项目
        {name: "project", text: h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')},
        // 是否合格
        {name: "qualifiedStatus", text: h_i18n('3ba97bd751e79dff382d6ca65e4e3553')},
        // 检测时间
        {name: "testTime", text: h_i18n('44c4227175922c94497714edab9db531')},
        // 附件
        {name: "fileUuid", text: h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')},
        // 报告出具人
        {name: "submitMan", text: h_i18n('1470d600e4e06f5ea0100fc0bd2a363c')}
      ]
      //检验测试
      let c = [
        // 项目
        {name: "project", text: h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')},
        // 是否合格
        {name: "qualifiedStatus", text: h_i18n('3ba97bd751e79dff382d6ca65e4e3553')},
        // 附件
        {name: "fileUuid", text: h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')},
        // 报告出具人
        {name: "submitMan", text: h_i18n('1470d600e4e06f5ea0100fc0bd2a363c')}
      ]
      //检验测试
      let d = [
        // 项目
        {name: "project", text: h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')},
        // 是否合格
        {name: "judge", text: h_i18n('3ba97bd751e79dff382d6ca65e4e3553')},
        // 附件
        {name: "fileUuid", text: h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')},
        // 报告出具人
        {name: "submitMan", text: h_i18n('1470d600e4e06f5ea0100fc0bd2a363c')}
      ]
      // 二三级物料
      let aa = this.checkEmpty(a, this.tableList.sTMaterialsList, h_i18n('749ad86b2e655706785f3e38b9e7031c'))
      // 检验测试
      let bb = this.checkEmpty(b, this.tableList.inspectionTesting, h_i18n('23e0cee4c780d1d70657b0b32005fed2'))
      // 技术标准
      let cc = this.checkEmpty(c, this.tableList.technicalStandard, h_i18n('542c3a3ec2d96f011386760d7382940f'))
      if (aa) {
        if (bb) {
          if (cc) {
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.pointer {
  cursor: pointer;
}
.page {
  margin-top: 12px;
  //.cell {
  //  div {
  //    text-align: left;
  //  }
  //}
  .item-look {
    display: inline-block;
  }

  .table-top {
    padding: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 10px;
    box-sizing: border-box;

    .title-table {
      display: flex;
      height: 30px;
      font-size: 14px;
      justify-content: space-between;
      font-weight: 500;
      color: #1D2129;
      .right {
        font-weight: 500;
      }
    }

    .item {
      margin-top: 10px;

      .item_table {
        width: 100%;

        tr {
          th {
            height: 40px;
            font-size: 16px;
            font-weight: 400;
          }

          td {
            height: 40px;
            font-size: 14px;
            font-weight: 400;
            text-align: center;
          }
        }
      }
    }
  }

  .table-tab {
    margin-top: 10px;
    background-color: #fff;
    padding: 4px 16px 16px;
    border-radius: 8px;
    .footer_check {
      display: flex;
      padding: 0 5px;
      font-size: 16px;
      color: #165DFF;
      font-weight: 900;
      justify-content: center;
      align-items: center;

      :deep(.el-checkbox) {
        display: flex;
        align-items: center;
      }

      :deep(.el-checkbox__input) {
        display: inline-flex;
        align-items: center;
      }

      :deep(.el-checkbox__label) {
        font-size: 16px;
      }
    }

    .demo-tabs {
      :deep(.el-tabs__content) {
        // padding: 10px;
        min-height: 320px;
      }

      .tab-item {
        width: 100%;
        height: 100%;

        .table-item-button {
          display: flex;

          .text {
            color: #D9001B;
            font-size: 16px;
            display: flex;
            margin-left: 20px;
            align-items: center;
          }
        }

        .table-item-list {
          display: flex;
          min-height: 25px;
          // margin-top: 10px;
          // border: 1px solid #E5E6EB;
          border-radius: 8px;
          overflow: hidden;
          height: 100%;

          .item-one {
            // min-width: 45px;
            flex: none;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            // border-left: 1px solid #E5E6EB;
            // padding: 0 10px;
            margin-right: 8px;
          }


          .item-bg {
            color: #4E5969;
            // background-color: #F1F2F8;
          }

          .item-one:first-child {
            border-left: 0;
          }

          .item-two {
            width: 0;
            // border-left: 1px solid #E5E6EB;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            flex: 1;
            line-height: 32px;
            padding: 0 10px;
            font-size: 14px;
          }
          .item-two:hover{
            white-space: normal;
            word-break: break-all;
            line-height: 20px;
          }
        }
      }
    }

    .text_item {
      white-space: nowrap;
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .text_item:hover {
      white-space: normal;
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .text_item_delete {
      user-select: none;
      display: inline-block;
    }
  }

  .table-footer {
    padding: 16px;
    background-color: #fff;
    margin-top: 10px;
    border-radius: 10px;
  }

  .row-change {
    .current-row {
      td {
        padding: 7.5px 0;
      }
    }
  }
}

.footer_check_ratify {
  display: flex;
  padding: 0 5px;
  font-size: 16px;
  color: #165DFF;
  font-weight: 900;
  height: 50px;
  justify-content: center;
  align-items: center;
}

:deep(.el-drawer__header) {
  margin-bottom: 10px;
  padding: 0 10px;
  font-weight: 900;
  border-bottom: 1px dashed #E5E6EB;
}

.titleDrawer {
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
}
.detail-content{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  //margin-left: 15px;
  .detail-item{
    width: 25%;
    display: flex;
    .item-label{
      min-width: 45px;
      font-size: 14px;
      color: #4E5969;
    }
    .item-content{
      font-size: 14px;
      color: #1D2129;
      .default_input_style{
        .el-textarea__inner{
          height: 100%;
          font-size: 14px;
        }
      }
    }
  }
}
.myTr :first-child{
  border-top-left-radius: 8px;
}
.myTr :last-child{
  border-top-right-radius: 8px;
}
.myTr1 :first-child {
  border-bottom-left-radius: 8px;
}
.myTr1 :last-child{
  border-bottom-right-radius: 8px;
}
</style>

<style scoped>
/* .config-provide{
  background: #F2F4F7;
} */
.h-hwork-form-page{
  width: 98%;
  margin: 0 auto;
}
.haier-title-lable{
  height: 48px;
  background: #fff !important;
}
.haier-form-area{
  background: #F2F4F7;
}
.haier-form-area .area .h-work-d-body{
  padding: 0;
}
.myTable{
  border-right: 1px solid #e5e6eb !important;
  border-bottom: 1px solid #e5e6eb !important;
}
.h-hwork-form-page .haier-title-lable{
  background: #fff;
}
</style>